<template>
  <v-container>
    <v-card>
      <v-card-title>
        <h1>{{ $t('login.text.title') }}</h1>
      </v-card-title>
      <v-form>
        <v-card-text>
          <v-alert v-for="e in errors.nonFieldErrors" :key="e" type="error">
            {{ e }}
          </v-alert>
          <v-text-field
            v-model="form.username"
            :error-messages="errors.username"
            :label="$t('login.text.username')"
            @keypress.enter="submit"
          />
          <v-text-field
            v-model="form.password"
            :error-messages="errors.password"
            :label="$t('login.text.password')"
            type="password"
            @keypress.enter="submit"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="primary" @click="submit">{{
            $t('login.button.login')
          }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <v-row justify="center" class="mt-8">
      <v-col cols="auto" class="d-flex align-center">
        <span
          v-for="(lang, index) in languages"
          :key="lang.code"
          class="language-item"
          :class="{
            'text-decoration-underline': currentLanguage === lang.code,
          }"
          @click="changeLanguage(lang.code)"
        >
          {{ $t(`language.${lang.code}`) }}
          <span v-if="index < languages.length - 1" class="mx-2">|</span>
        </span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { switchLocale } from '@/router'
export default {
  data: () => ({
    form: {
      username: null,
      password: null,
    },
    errors: {},
    languages: [{ code: 'ja' }, { code: 'en' }, { code: 'th' }],
  }),

  computed: {
    ...mapGetters(['loggedIn']),
    next() {
      return this.$route.query.next
    },
    currentLanguage() {
      return this.$i18n.locale
    },
  },
  created() {
    if (this.loggedIn) this.$router.push(this.next || '/')
  },
  methods: {
    ...mapActions(['login']),
    async submit() {
      try {
        this.errors = {}
        await this.login(this.form)
        this.$router.push(this.next || '/')
      } catch (err) {
        console.error(err)
        this.errors = this.$getValidationErrors(err)
      }
    },
    changeLanguage(language) {
      // Same routine as App.vue - see switchLocale() in src/router.ts
      switchLocale(this, language)
    },
  },
}
</script>

<style scoped>
.language-item {
  cursor: pointer;
  user-select: none;
}
</style>
